import { Button, IconButton, Modal, TextField, Theme, Typography } from "@mui/material";
import { Box, Stack, SxProps } from "@mui/system";
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { useAnalytics } from "../firebase/firebase";
import { FavouritesContext } from "../favourites/favouritesProvider";
import { useState } from "react";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { CSSProperties } from "@mui/styled-engine";
import { useTheme } from '@mui/material/styles';
import { TiledBackground } from "../theme/background";

interface ChooseFavouritesFolderModalProps {
    open: boolean;
    setOpen: (b: boolean) => void;
    chooseFolderHandler: (id: number) => void;
}

export const ChooseFavouritesFolderModal = (props: ChooseFavouritesFolderModalProps) => {
    const { track } = useAnalytics();
    const [newFolderName, setNewFolderName] = useState<string>("");
    const { folders, createFolder } = useContextWithGuard(FavouritesContext, "AlbumContext");
    const theme = useTheme();

    const style: SxProps = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
  width: '90vw',                // Responsive width
  maxWidth: 400,                // Don’t exceed your original design
  maxHeight: '90vh',            // Prevent overflow on small screens
        background: theme.bee.barBackground,
        border: '2px solid #000',
        boxShadow: "24",
        p: 4,
        overflow: "scroll",
    };

    return (
        <Modal
            open={props.open}
            onClose={() => props.setOpen(false)}
            aria-labelledby="choose folder"
        >
            <Box sx={style}>
                <TiledBackground offset={0} />
                <Stack direction="column" spacing={2}>

                    <Typography variant="h5"sx={{borderBottom: "solid 1px black"}}>
                        Add to favourites
                    </Typography>

                    <Typography>
                        Choose a folder
                    </Typography>

                    <Stack direction="column" spacing={1}>
                        {folders.map((f) => (
                            <Button
                                key={f.id}
                                onClick={(e) => {
                                    props.setOpen(false);
                                    props.chooseFolderHandler(f.id);
                                }}
                                variant="contained"
                            >
                                {f.name}
                            </Button>
                        ))}
                    </Stack>

                    <Typography>
                        Or create a new folder
                    </Typography>

                    <Stack direction="row" spacing={3}>

                        <TextField
                            value={newFolderName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setNewFolderName(e.target.value);
                            }}
                            sx={{
                                backgroundColor: "#eee"
                            }}
                            placeholder="name" />

                        <IconButton
                            size="large"
                            edge="start"
                            aria-label="settings"
                            sx={{
                                mr: 2,
                            }}
                            aria-haspopup="true"
                            onClick={() => {
                                if (newFolderName) createFolder(newFolderName);
                            }}
                            title="add folder"
                            color="primary"
                        >
                            <AddCircleIcon />
                        </IconButton>
                    </Stack>
                </Stack>
            </Box>
        </Modal >
    )
}